<template>
  <component v-if="!list.hideComponent" :is="list.skipCardLayout?'div':'md-card'">
    <md-card-header
      class="md-card-header-icon md-card-header-green list-header"
      :class="list.hideListHeader? 'list-header-hidden' : ''"
    >
      <template v-if="!list.hideListHeader">
        <h4 class="title">{{ list.pageTitle }}</h4>
      </template>
      <button
        v-if="!list.skipCardLayout && !list.hideNewRecordButton"
        v-on:click="newRecord()"
        class="md-button md-primary md-sm"
        style="float:right"
      >
        Add
        <md-icon class="md-small">control_point</md-icon>
      </button>
      <md-button
        v-if="list.showRefreshIcon"
        id="messageListRefresh"
        class="md-just-icon md-simple"
        @click="refresh()"
      >
        <md-icon>refresh</md-icon>
      </md-button>
    </md-card-header>

    <component
      v-if="onlyShowListIf === null || onlyShowListIf"
      :is="list.skipCardLayout?'div':'md-card-content'"
    >
      <div class="dynamicList-loading" v-show="isPromisePending">
        <md-progress-spinner :md-diameter="40" :md-stroke="4" md-mode="indeterminate" />
      </div>
      <md-snackbar
        :md-position="'center'"
        :md-duration="4000"
        :md-active.sync="searchError"
        md-persistent
      >
        <span>{{searchErrorMessage}}</span>
      </md-snackbar>

      <md-table
        :value="queriedData"
        :md-sort.sync="currentSort"
        :md-sort-order.sync="currentSortDir"
        :md-sort-fn="customSort"
        :searchQuery="searchQuery"
        class="paginated-table table-striped table-hover"
      >
        <md-table-toolbar v-if="list.showTableToolbar" class="hide-overflow">
          <md-field>
            <md-input
              type="search"
              class="mb-3"
              clearable
              style="width: 200px"
              placeholder="Search records"
              v-model="searchQuery"
              ref="searchQuery"
            ></md-input>
          </md-field>

          <md-field>
            <label for="pages">Per page</label>
            <md-select v-model="currentPerPage" :key="'perPage' + activeDataName" name="pages">
              <md-option
                v-for="item in list.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              >{{ item }}</md-option>
            </md-select>
          </md-field>
        </md-table-toolbar>

        <md-table-row slot="md-table-row" slot-scope="{ item }" :class="ifOverdueTask(item) ? 'textRed' : ''">
          <template v-for="(column, name) in list.columns">
            <template v-if="list.HyperLinkColumns && list.HyperLinkColumns.colName === name">
              <md-table-cell :key="name" :md-label="column.label" :md-sort-by="column.sortable? name : null">
                <a :href="getCaseHref(list.HyperLinkColumns, item)">
                  {{ getColumnDisplayValue(column, item, name) }}
                </a>
              </md-table-cell>
            </template>
            <template v-else>
              <md-table-cell :key="name" :md-label="column.label" :md-sort-by="column.sortable? name : null">{{ getColumnDisplayValue(column, item, name) }}</md-table-cell>
            </template>
          </template>

          <md-table-cell md-label="Actions" v-if="list.showItemActions">
            <template v-if="list.itemActions">
              <template v-for="(action) in list.itemActions">
                <md-button
                  :key="action.icon"
                  :class="item.added? action.classAdded : action.class"
                  @click.native="callItemAction(action.click, item)"
                >
                  <md-icon class="style-icon">{{item.added? action.iconAdded : action.icon}}</md-icon>
                </md-button>
              </template>
            </template>
            <template v-else>
              <md-button class="md-just-icon md-warning md-simple" @click.native="handleEdit(item)">
                <md-icon>description</md-icon>
              </md-button>

              <md-button
                class="md-just-icon md-danger md-simple"
                @click.native="handleDelete(item)"
              >
                <md-icon>close</md-icon>
              </md-button>
            </template>
          </md-table-cell>
        </md-table-row>
      </md-table>
    </component>

    <md-card-actions md-alignment="space-between" v-if="list.showActionResults">
      <div class>
        <p
          v-if="queriedData.length"
          class="card-category"
        >Showing {{ from + 1 }} to {{ to }} of {{ activeData.total }} results</p>
        <p v-else class="card-category">0 results</p>
      </div>
      <pagination
        v-show="queriedData.length"
        class="pagination-no-border pagination-success"
        v-model="activeData.curPage"
        :per-page="currentPerPage"
        :total="activeData.total"
      ></pagination>
    </md-card-actions>
  </component>
</template>

<script>
import RecordList from "@/mixins/RecordList";
import moment from "moment";

export default {
  mixins: [RecordList],
  watch: {
    "$route.params": function() {
      if (this.$route.query.q)
        this.$refs["searchQuery"].value = this.$route.query.q;
    },
    /**
     * ATLAS-577 - Dashboard>>My Task List : Clicking on Load more button,additional Task are not showing
     * Watch for changes to loadNextItems 
     * When changed update local variable currentPerPage to show next page items
     */
    'list.defaults.loadNextItems': {
      handler: function() {
        const numOfItemsToShow = this.$reduce(this, 'data.default.items.length');
        if (numOfItemsToShow) {
          this.currentPerPage = numOfItemsToShow;
        }
      }
    }
  },
  created() {
    if (this.$route.query.q) this.searchQuery = this.$route.query.q;
  },
  methods: {
    callItemAction(funcName, item) {
      if (typeof this[funcName] === "function") {
        return this[funcName](item);
      }
    },
    getCaseHref(listColumns, item) {
      const path = '#/' + listColumns.editColLink + '/' + item[listColumns.fieldId] + '?tab=' + listColumns.tabName;
      return path;
    },
    ifOverdueTask(item) {
      if(item.dateDue){
        if(moment(item.dateDue) <= moment().add(-1, 'days')){
          return true
        }else{
          return false
        }
      }else{
        return false
      }
    },
  }
};
</script>

<style lang="css" scoped>
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}

.md-card-header.list-header.list-header-hidden {
  padding-top: 12px;
}

.dynamicList-loading {
  position: absolute;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  bottom: auto;
  right: auto;
  display: block;
}

.md-card .md-card-header.md-card-header-icon .title {
  font-weight: 500;
}

.textRed{
  color: red;
}
</style>
